import { render, staticRenderFns } from "./OverlayClassesModal.vue?vue&type=template&id=00251154"
import script from "./OverlayClassesModal.vue?vue&type=script&lang=js"
export * from "./OverlayClassesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports